/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Not_ConfiguredInputs */

const cs_sms_not_configured = /** @type {(inputs: Sms_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brána není nastavená`)
};

const en_sms_not_configured = /** @type {(inputs: Sms_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway not configured`)
};

/**
* | output |
* | --- |
* | "Gateway not configured" |
*
* @param {Sms_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_not_configured = /** @type {((inputs?: Sms_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_not_configured(inputs)
	return cs_sms_not_configured(inputs)
});